import AssessmentQuiz from './AssessmentQuiz';

export default AssessmentQuiz;



// WEBPACK FOOTER //
// ./src/pages/gdpr-assessment-tool/containers/AssessmentQuiz/index.js